import styled from 'styled-components';

export const NavigationStyleContainer = styled.section(
  props => `
  width: 100%;
  background-color: ${props.theme.colors.goWhite.base};
  position:sticky;
  top:8.6rem;
  z-index: ${props.theme.misc.zIndex.base};
  height:6.3rem;
  box-shadow: 0 1px 5px ${props.theme.colors.shadow.base};

  &.active {
    box-shadow: 0 1px 5px ${props.theme.colors.shadow.base}
  }
`,
);

export const StyledWrapper = styled.div(
  props => `
  max-width: 120rem;
  width: 100%;
  margin: 0 auto;
  height: 100%;
`,
);

export const MenuList = styled.ul(
  props => `
  list-style: none;
  display: flex;
  min-height: 6rem;
  width: 100%;
  height: 100%;
`,
);

export const TextWrapperSpan = styled.div(
  props => `
  font-size: ${props.theme.font.custom(16)};
  height: 100%;
  a {
    
  }

  &.active {
    font-weight: bold;
    border-bottom: 0.3rem solid ${props.theme.colors.goBrandBlue.base};
    border-radius: 0.2rem;
    a {
      color: ${props.theme.colors.goBrandBlue.base};
    }
  }
`,
);

export const ItemLinkTo = styled.a(
  props => `
  text-decoration: none;
  color: ${props.active ? props.theme.colors.goBrandBlue.base : props.theme.colors.downriver.base};
  padding: 0 ${props.theme.spacing.xlarge};

  height: 100%;
  /* for centering of text */
  display: flex;
  align-items: center;
`,
);
